import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

import { useBefehlForm } from '../../../hooks'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl26 } from '../../../models'
import {
  convertBefehl26FormDataToModel,
  convertModelToBefehl26FormData
} from './converters'
import { Befehl26FormData, createBefehl26FormValidationSchema } from './schema'
import Auftrag26_10Form from './Auftrag26_10Form'

/**
 * Main form component for Befehl 26
 */

export default function Befehl26Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-26-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl26>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl26FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl26FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl26FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl26FormData) => {
      const updatedBefehl = convertBefehl26FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl26FormData>
      befehlKennung="26"
      title={t('befehle.26.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <div className="flex flex-col gap-2">
        {/* Auftrag 26.10 */}
        <Auftrag26_10Form
          readOnly={readOnly}
          data-testid={`${testId}-auftrag-26-10`}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />
      </div>
    </BefehlFormWrapper>
  )
}
